#import "src/allocation/graphql/allocation.graphql"
#import "./memberFragment.graphql"
#import "./teamFragment.graphql"

query getTeamDetail($teamId: String!) {
  team: getGroup(groupId: $teamId) {
    ...TeamDetailsFragment
  }
}

query getMissingTeamsForDiff($groupIds: [String]) {
  getGroups(groupIds: $groupIds) {
    directChildTeamCount
    ...TeamDetailsFragment
    ...TeamMemberCountFragment
  }
}

# Lean stubs for diff reconciliation of teams/members that left/joined a parent
# roster between pits. Fetched by id at a pit date (x-pit-date header). Each side
# (groups/people) is skipped when it has no ids to avoid fetching unfiltered lists.
query getDiffMembersAndChildTeams(
  $groupIds: [String]
  $memberIds: [String!]
  $skipTeams: Boolean!
  $skipMembers: Boolean!
) {
  childTeams: getGroups(groupIds: $groupIds) @skip(if: $skipTeams) {
    id
    name
    kind
    type
    isHidden
    isDeleted
    directParentId
    hierarchyIds
    memberCount
    childTeamCount
    directMemberCount
    directChildTeamCount
  }
  members: getPeopleByIds(ids: $memberIds, includeDepartedPeople: true)
    @skip(if: $skipMembers) {
    aggregateId
    employeeId
    firstName
    surname
    preferredName
    jobTitle
    avatar
    fte
    isPlaceholder
    disabled
  }
}

query getMemberCountForTeams($teamIds: [String]) {
  teams: getGroups(groupIds: $teamIds) {
    ...TeamMemberCountFragment
  }
}

query listPrincipleSets($experimentalFeaturesEnabled: Boolean = false) {
  principleSets: listPrincipleSets(
    includeExperimental: $experimentalFeaturesEnabled
  ) {
    name
    id
    suitableGroupTypes
  }
}

mutation selectPrincipleSet($teamId: ID!, $principleSetId: ID) {
  team: selectPrincipleSet(groupId: $teamId, principleSetId: $principleSetId) {
    id
    principleSetId
    principles {
      met
      title
      details
    }
  }
}

mutation updateGroupName($groupId: ID!, $name: String!) {
  result: updateGroupName(groupId: $groupId, name: $name) {
    id
    name
    hierarchyIds
    hierarchy
  }
}

mutation updateTeamAttributes($groupId: ID!, $attributes: [AttributesInput]) {
  group: updateGroupAttributes(groupId: $groupId, attributes: $attributes) {
    id
    attributes {
      id
      attributeType
      subtype
      label
      value
    }
  }
}

query getTeamCsvExport($groupId: String!) {
  csvExport: getGroupCsvExport(groupId: $groupId) {
    content
  }
}

query getPrincipleStatus($teamId: String!) {
  team: getGroup(groupId: $teamId) {
    id
    principles {
      met
      title
      details
      signal {
        color
        text
      }
    }
  }
}
